import request from '@/utils/request'

/**
 * 更新系统任务(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sysjobUpdate(data) {
  return request({
    type: 'biz',
    url: 'sysjob/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/SysJob.js